import React from "react";
import {
  DialogContent,
  CardContent,
  Card,
  makeStyles,
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import Spin from "components/ui/Spin";
import JSONPretty from 'react-json-pretty';

export const ViewData = (props) => {
  const { visible, handleDialogClose} = props;
  let newData  = props.data;
  const useStyle = makeStyles((theme) => ({
    table: {
      marginBottom: "1rem",
    },
    card: {
      "& .MuiCardHeader-root": {
        padding: "12px",
        paddingBottom: 0,
      },
      "& .MuiCardContent-root": {
        padding: 0,
      },
    },
  }));
  const classes = useStyle();

  const handleClose = (_) => {
    handleDialogClose(false);
  };

  return (
    <Spin >
      <KisshtDialog
        title="View API Response"
        maxWidth={"md"}
        open={visible}
        handleClose={handleClose}
      >
        <DialogContent>
          <Card className={classes.card}>
            <CardContent>
              <p>{newData ? <JSONPretty id="json-pretty" data={newData}></JSONPretty> : "No Data Found"}</p>
            </CardContent>
          </Card>
        </DialogContent>
      </KisshtDialog>
    </Spin>
  );
};
export default ViewData;